import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ForgotPasswordFormComponent } from './components/forgot-password-form/forgot-password-form.component';
import { SecondaryLogoComponent } from '../../components/shared/secondary-logo/secondary-logo.component';
import { NgOptimizedImage } from '@angular/common';
import { ForgotPasswordSuccessComponent } from './components/forgot-password-success/forgot-password-success.component';

@Component({
  selector: 'app-forgot-password-page',
  standalone: true,
  imports: [
    ForgotPasswordFormComponent,
    SecondaryLogoComponent,
    NgOptimizedImage,
    ForgotPasswordSuccessComponent,
  ],
  templateUrl: './forgot-password-page.component.html',
  styleUrl: './forgot-password-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordPageComponent {
  public isRequestSuccessful = signal<boolean>(false);
  public submittedEmail = signal<string>('');

  public onRequestSuccess(email: string): void {
    this.submittedEmail.set(email);
    this.isRequestSuccessful.set(true);
  }
}
